import { Space } from "antd";

const Settings = () => {
 

  return (
    <Space direction="horizontal" wrap size={[10]} style={{ margin: "10px" }}>
       <h1> </h1>
    </Space>
  );
};

export default Settings;
